<!--物业的看板-->
<template>
	<div>
		<div class="flexBetween" style="display: flex;height: calc(50% - 10px);margin: 10px;">
			<div style="width: calc(50% - 10px);height: 100%;">
				<div class="overviewBox" style="width: calc(100% - 40px);height: calc(60% - 20px);padding: 10px 20px;">
					<p class="overview-title">小区概况</p>
					<div class="flexBetween">
						<div class="unitInfo">
							<div style="background: #409EFF;" class="flexCenter icoDiv">
								<img :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/meterOnline.png')">
							</div>
							<div class="flexCenter" style="margin-top: 10px;">
								<p style="color: #FF9900;">560</p>
								<p>|</p>
								<p>566</p>
							</div>
							<p class="smallTitle">电能表上线数</p>
						</div>
						<div class="unitInfo">
							<div style="background: #67C23A;" class="flexCenter icoDiv">
								<img :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/unPay.png')">
							</div>
							<div class="flexCenter" style="margin-top: 10px;">
								<p style="color: #FF9900;">69</p>
								<p>|</p>
								<p>566</p>
							</div>
							<p class="smallTitle">欠费未缴纳数</p>
						</div>
						<div class="unitInfo">
							<div style="background: #FF9900;" class="flexCenter icoDiv">
								<img :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/customer.png')">
							</div>
							<div class="flexCenter" style="margin-top: 10px;">
								<p>566</p>
							</div>
							<p class="smallTitle">客户数</p>
						</div>
						<div class="unitInfo">
							<div style="background: #339999;" class="flexCenter icoDiv">
								<img :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/warn.png')">
							</div>
							<div class="flexCenter" style="margin-top: 10px;">
								<p style="color: #FF9900;">32</p>
								<p> | </p>
								<p>802</p>
							</div>
							<p class="smallTitle">未确认报警数</p>
						</div>
					</div>
				</div>
				<div class="overviewBox" style="width: calc(100% - 20px);margin-top: 10px;height: calc(40% - 30px);padding: 10px;">
					<p class="overview-title">实时缴费信息</p>
					<div class="custom-scrollbar" style="height: calc(100% - 30px);">
						<div class="flexStart" v-for="item in recordList" style="margin-bottom: 5px;">
							<span style="color: #FF9900;border: #FF9900 1px solid;border-radius: 3px;">{{item.time}}</span>
							<span style="margin-left: 10px;"> {{item.user}} 通过 </span>
							<span style="color: #409EFF;margin:0 10px;"> {{item.way}} </span>
							<span> 缴纳电费 {{item.money}}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="overviewBox" style="width: calc(25% - 25px);margin-left:10px; height: calc(100% - 20px);padding: 10px;">
				<p class="overview-title">缴费方式</p>
				<vchart style="height: calc(100% - 30px - 70px);width: 100%;" ref='vchart'></vchart>
				<div>
					<p class="payCount">微信 65735 元</p>
					<p class="payCount">支付宝 56568 元</p>
					<p class="payCount">银联 11234 元</p>
					<p class="payCount">人工缴费 5123 元</p>
				</div>
			</div>
			<div class="overviewBox" style="width: calc(25% - 25px);margin-left:10px; height: calc(100% - 20px);padding: 10px;">
				<p class="overview-title">预警概况</p>
				<vchart style="height: calc(100% - 30px - 70px);width: 100%;" ref='vchart2'></vchart>
				<div>
					<p class="payCount">通讯中断 114 次</p>
					<p class="payCount">欠费告警 12 次</p>
					<p class="payCount">清缴通知 10 次</p>
				</div>
			</div>
		</div>
		<yearOrMonthkWh class="overviewBox" style="width: calc(100% - 20px);margin: 10px;height: calc(50% - 20px);"></yearOrMonthkWh>
	</div>

</template>

<script>
	import yearOrMonthkWh from '@/page/system/meterReading/yearOrMonthkWh.vue'
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			yearOrMonthkWh,
			vchart
		},
		props: {},
		data() {
			return {
				recordList: [{
						time: '1天前',
						user: '103业主',
						way: '支付宝',
						money: '100元'
					}, {
						time: '1天前',
						user: '216业主',
						way: '微信',
						money: '200元'
					}, {
						time: '2天前',
						user: '311业主',
						way: '银联',
						money: '200元'
					},
					{
						time: '3天前',
						user: '321业主',
						way: '支付宝',
						money: '100元'
					}
				],
				optionsPie: {
					color: ['#00BFEF', '#ff9a16', '#ff6c4e', '#FBD437', ],
					tooltip: {
						trigger: 'item',
						formatter: "{a}</br>{b} : {c} ({d}%)"
					},
					legend: {
						show: false,
					},
					series: []
				}
			}
		},
		created() {
		},
		mounted() {
			//初始化图表
			this.$refs.vchart.setData(this.optionsPie)
			this.$refs.vchart2.setData(this.optionsPie)
			setTimeout(() => {
				this.$refs.vchart.setData({
					series: [{
						name: '缴费方式',
						type: 'pie',
						data: [{
							name: '微信',
							value: 65735,
						}, {
							name: '支付宝',
							value: 56568,
						}, {
							name: '银联',
							value: 11234,
						}, {
							name: '人工缴费',
							value: 5123,
						}]
					}]
				})
				this.$refs.vchart2.setData({
					series: [{
						name: '告警类型',
						type: 'pie',
						data: [{
							name: '通讯中断',
							value: 114,
						}, {
							name: '欠费告警',
							value: 12,
						}, {
							name: '清缴通知',
							value: 10,
						}]
					}]
				})
			}, 1000)
		},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {

		}
	}
</script>

<style scoped>
	.overviewBox {
		background: white;
	}

	.overview-title {
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 10px;
	}

	.unitInfo img {
		max-width: 80%;
		max-height: 80%;
	}

	.unitInfo .icoDiv {
		width: 75px;
		height: 75px;
		border-radius: 50%;
		margin-top: 10px;
	}

	.unitInfo .smallTitle {
		margin-top: 10px;
		text-align: center;
	}

	.payCount {
		border: #E4E4E4 solid 1px;
		border-radius: 3px;
		width: calc(50% - 12px);
		display: inline-block;
		text-align: center;
		line-height: 30px;
		margin: 0 5px 5px 5px;
	}
</style>
